import styled from '@emotion/styled'

export const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  height: 76px;
  background-color: #f5f5f5;
  min-width: 280px;
`

export const ModalTitle = styled.h1(
  ({ theme }) => `
  margin: auto ${theme.ds.Space3X};
  font-size: 20px;
  font-weight: 600;
`
)

export const ModalCloseButton = styled.button(
  ({ theme }) => `
  font-family: inherit;
  margin: auto ${theme.ds.Space3X} auto auto;
  height: ${theme.ds.Space3X};
  width: 75px;
  background: none;
  font-size: 14px;
  font-weight: 500;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  text-align: right;
  line-height: 15px;
  color: ${theme.ds.ColorBaseGreyLevel4};

  & > svg  {
    stroke: ${theme.ds.ColorBaseGreyLevel4};
    margin-right: ${theme.ds.Space1X};
    position: absolute;
    left: 0;
    top: 0;
  }
`
)
